import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { GridComponent } from './components/grid/grid.component';
import { httpInterceptorProviders } from './interceptors/http-interceptors/providers';
import { SharedModule } from './shared-layout/shared.module';
import { AuthguardService } from './services/http-services/authguard.service';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VexModule } from 'src/@vex/vex.module';
import { CreateExaminationComponent } from './exam-layout/create-examination/create-examination.component';
import { ExaminationCandidatesComponent } from './exam-layout/examination-candidates/examination-candidates.component';
import { ExaminationPortalApiParametersComponent } from './exam-layout/examination-portal-api-parameters/examination-portal-api-parameters.component';
import { ExaminationScriptComponent } from './exam-layout/examination-script/examination-script.component';
import { ExaminationSubjectsComponent } from './exam-layout/examination-subjects/examination-subjects.component';
import { ExaminationVenuesComponent } from './exam-layout/examination-venues/examination-venues.component';
import { ExaminationsComponent } from './exam-layout/examinations/examinations.component';
import { AutoDpsComponent } from './exam-layout/operations/auto-dps/auto-dps.component';
import { CreateQuestionsComponent } from './exam-layout/operations/create-questions/create-questions.component';
import { ExamCopyComponent } from './exam-layout/operations/exam-copy/exam-copy.component';
import { ExamQuestionsComponent } from './exam-layout/operations/exam-questions/exam-questions.component';
import { ExamUrlComponent } from './exam-layout/operations/exam-url/exam-url.component';
import { ExportQuestionsComponent } from './exam-layout/operations/export-questions/export-questions.component';
import { PauseUnpauseExamComponent } from './exam-layout/operations/pause-unpause-exam/pause-unpause-exam.component';
import { TestQuestionsComponent } from './exam-layout/operations/test-questions/test-questions.component';
import { UploadQuestionsComponent } from './exam-layout/operations/upload-questions/upload-questions.component';
import { MatIconModule } from '@angular/material/icon';
import { QuillModule } from 'ngx-quill';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DataTablesModule } from 'angular-datatables';
import { ExaminationscheduleUnitsConfigComponent } from './examschedule-layout/examinationschedule-units-config/examinationschedule-units-config.component';
import { ExaminationscheduleComponent } from './examschedule-layout/examinationschedule/examinationschedule.component';
import { ExpectedScheduleComponent } from './examschedule-layout/expected-schedule/expected-schedule.component';
import { ForgotPasswordComponent } from './auth-layout/forgot-password/forgot-password.component';
import { LoginComponent } from './auth-layout/login/login.component';
import { RequestPasswordSuccessComponent } from './auth-layout/request-password-success/request-password-success.component';
import { ResetPasswordSuccessComponent } from './auth-layout/reset-password-success/reset-password-success.component';
import { ResetPasswordComponent } from './auth-layout/reset-password/reset-password.component';
import { SendCandidatesEmailComponent } from './candidates-layout/send-candidates-email/send-candidates-email.component';
import { SendCandidatesSmsComponent } from './candidates-layout/send-candidates-sms/send-candidates-sms.component';
import { UploadCandidatePassportComponent } from './candidates-layout/upload-candidate-passport/upload-candidate-passport.component';
import { TimePeriodsComponent } from './misc-layout/time-periods/time-periods.component';
import { CbtPortalParameterComponent } from './parameter-layout/cbt-portal-parameter/cbt-portal-parameter.component';
import { WebtestParametersComponent } from './parameter-layout/webtest-parameters/webtest-parameters.component';
import { ProctorServerConfigComponent } from './proctor-layout/proctor-server-config/proctor-server-config.component';
import { ProctorsComponent } from './proctor-layout/proctors/proctors.component';
import { AddunitsComponent } from './units-layout/addunits/addunits.component';
import { BuyunitsComponent } from './units-layout/buyunits/buyunits.component';
import { UnitsPriceConfigComponent } from './units-layout/units-price-config/units-price-config.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExamFeedbackComponent } from './exam-layout/operations/exam-feedback/exam-feedback.component';
import { ExamResultCardComponent } from './exam-layout/operations/exam-result-card/exam-result-card.component';
import { ExamResultCategoryComponent } from './exam-layout/operations/exam-result-category/exam-result-category.component';
import { ExamResultComponent } from './exam-layout/operations/exam-result/exam-result.component';
import { ExamScriptComponent } from './exam-layout/operations/exam-script/exam-script.component';
import { QuestionReportComponent } from './exam-layout/operations/question-report/question-report.component';
import { FileDownloadComponent } from './file-download/file-download/file-download.component';
import { ViewCandidateComponent } from './candidates-layout/view-candidate/view-candidate.component';
import { QuestionBankComponent } from './exam-layout/question-bank/question-bank.component';
import { ExamScheduleQuestionsComponent } from './examschedule-layout/exam-schedule-questions/exam-schedule-questions.component';
import { ExamScheduleEssayQuestionsComponent } from './examschedule-layout/exam-schedule-essay-questions/exam-schedule-essay-questions.component';
import { ExamScheduleBackupsComponent } from './examschedule-layout/exam-schedule-backups/exam-schedule-backups.component';
import { ExamScheduleAddedTimeLogComponent } from './examschedule-layout/exam-schedule-added-time-log/exam-schedule-added-time-log.component';
import { ExamSchedulePausedTimeLogComponent } from './examschedule-layout/exam-schedule-paused-time-log/exam-schedule-paused-time-log.component';
import { ExamScheduleFlagsComponent } from './examschedule-layout/exam-schedule-flags/exam-schedule-flags.component';
import { EssayExamLogComponent } from './exam-layout/essay-exam-log/essay-exam-log.component';
import { ExtraFieldsLabelComponent } from './exam-layout/extra-fields-label/extra-fields-label.component';
import { ConfirmExamScheduleRestartComponent } from './examschedule-layout/confirm-exam-schedule-restart/confirm-exam-schedule-restart.component';
import { ConfirmComponent } from './shared-layout/confirm/confirm.component';
import { RecomputeIssueScoreComponent } from './examschedule-layout/recompute-issue-score/recompute-issue-score.component';
import { AddTimeComponent } from './examschedule-layout/add-time/add-time.component';
import { PauseCandidateExamComponent } from './examschedule-layout/pause-candidate-exam/pause-candidate-exam.component';
import { ChangeExamStatusComponent } from './examschedule-layout/change-exam-status/change-exam-status.component';
import { ChangeExamScheduleStartDateTimeComponent } from './examschedule-layout/change-exam-schedule-start-date-time/change-exam-schedule-start-date-time.component';
import { ScheduleCandidateComponent } from './exam-layout/operations/schedule-candidate/schedule-candidate.component';
import { VerifyPaymentComponent } from './units-layout/verify-payment/verify-payment.component';
import { ExamScriptReportComponent } from './examschedule-layout/exam-script-report/exam-script-report.component';
import { ImportScheduleCandidateComponent } from './exam-layout/operations/import-schedule-candidate/import-schedule-candidate.component';
import { TemplateDownloadComponent } from './exam-layout/operations/template-download/template-download.component';
import { ExamCategoryComponent } from './exam-layout/operations/exam-category/exam-category.component';
import { AddCategoryComponent } from './exam-layout/operations/add-category/add-category.component';
import { CardBoxComponent } from './components/card-box/card-box.component';
import { ExamPenaltyComponent } from './exam-layout/exam-penalty/exam-penalty.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { SebInstructionUrlComponent } from './exam-layout/operations/seb-instruction-url/seb-instruction-url.component';
import { GenerateSebConfigComponent } from './exam-layout/operations/generate-seb-config/generate-seb-config.component';
import { ComplaintsComponent } from './complaint-layout/complaints/complaints.component';
import { ViewComplaintComponent } from './complaint-layout/view-complaint/view-complaint.component';
import { EmailMessagesComponent } from './messages/email-messages/email-messages.component';
import { SmsMessagesComponent } from './messages/sms-messages/sms-messages.component';
import { MarkEssayComponent } from './exam-layout/operations/mark-essay/mark-essay.component';
import { MarkSaqComponent } from './exam-layout/operations/mark-saq/mark-saq.component';
import { ScoreAdjustmentModalComponent } from './exam-layout/Shared/score-adjustment-modal/score-adjustment-modal.component';
import { UploadQuestionsImageComponent } from './exam-layout/operations/upload-questions-image/upload-questions-image.component';
import { UploadMarksheetComponent } from './exam-layout/operations/upload-marksheet/upload-marksheet.component';
import { AssignExaminersComponent } from './exam-layout/operations/assign-examiners/assign-examiners.component';
import { GenerateMarkSheetComponent } from './exam-layout/operations/generate-mark-sheet/generate-mark-sheet.component';
import { ExamScoreByIpComponent } from './exam-layout/operations/exam-score-by-ip/exam-score-by-ip.component';
import { ExamInstructionsComponent } from './exam-layout/operations/exam-instructions/exam-instructions.component';
import { ComplaintCategoryComponent } from './complaint-layout/complaint-category/complaint-category.component';
import { AddComplaintCategoryComponent } from './complaint-layout/add-complaint-category/add-complaint-category.component';
import { ComplaintCategoryMappingComponent } from './complaint-layout/complaint-category-mapping/complaint-category-mapping.component';
import { AddComplaintCategoryMappingComponent } from './complaint-layout/add-complaint-category-mapping/add-complaint-category-mapping.component';
import { QuestionCategoriesComponent } from './exam-layout/operations/question-categories/question-categories.component';
import { VeiwScheduleComponent } from './examschedule-layout/veiw-schedule/veiw-schedule.component';
import { ExamExaminersComponent } from './exam-layout/operations/exam-examiners/exam-examiners.component';
import { AddExaminerComponent } from './exam-layout/operations/add-examiner/add-examiner.component';
import { PasswordUpdateComponent } from './auth-layout/password-update/password-update.component';
import { UpdateSaqAnswersComponent } from './exam-layout/operations/update-saq-answers/update-saq-answers.component';
import { ExamSaqAnswersUpdateComponent } from './exam-layout/operations/exam-saq-answers-update/exam-saq-answers-update.component';
import { FilterParticipantsPipe } from './pipes/filter-participants.pipe';
import { ProcteeComponent } from './monitoring/proctee/proctee.component';
import { ProcteesComponent } from './monitoring/proctees/proctees.component';
import { ToastrModule } from 'ngx-toastr';
import { CountdownModule } from 'ngx-countdown';
import { SettingsComponent } from './monitoring/settings/settings.component';
import { VideosComponent } from './recordings/videos/videos.component';
import { ProcteeflagsComponent } from './recordings/procteeflags/procteeflags.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { QuillEditorComponent } from './components/quill-editor/quill-editor.component';
import { ExaminationGroupComponent } from './exam-layout/examination-group/examination-group.component';
import { ExaminersMarkingReportComponent } from './exam-layout/operations/exam-examiners-marking-report/exam-examiners-marking-report.component';
import { ExaminersReviewReportComponent } from './exam-layout/operations/exam-examiners-review-report/exam-examiners-review-report.component';
import { ExamMarkingSummaryReportComponent } from './exam-layout/operations/exam-marking-summary-report/exam-marking-summary-report.component';
import { ImportCandidatesDataComponent } from './exam-layout/operations/ImportCandidatesData/ImportCandidatesData.component';
import { CompanySettingsComponent } from './company-settings/company-settings.component';
import { IconService } from './services/icon-service.service';
import { CandidateSebLockoutsComponent } from './candidates-layout/operations/candidate-seb-lockouts/candidate-seb-lockouts.component';
import { ExamScoreByMacComponent } from './exam-layout/operations/exam-score-by-mac/exam-score-by-mac.component';
import { DraggableDirective } from './directives/Draggable.directive';
import { CategorySelectComponent } from './exam-layout/Shared/category-select/category-select.component';
import { AddScheduleFlagsComponent } from './examschedule-layout/add-schedule-flags/add-schedule-flags.component';
import { ViewExamScriptComponent } from './exam-layout/operations/view-exam-script/view-exam-script.component';
import { ExamQuestionAnalysisComponent } from './exam-layout/operations/exam-question-analysis/exam-question-analysis.component';
import { ExamQuestionAnalysisExcelComponent } from './exam-layout/operations/exam-question-analysis-excel/exam-question-analysis-excel.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ImportPasswordsComponent } from './candidates-layout/import-passwords/import-passwords.component';

import { QuestionsBankComponent } from './questions-bank/questions-bank.component';
import { CreateUpdateQuestionComponent } from './questions-bank/create-update-question/create-update-question.component';
import { QuestionsComponent } from './questions-bank/questions/questions.component';
import { CreateUpdateQuestionBankComponent } from './questions-bank/create-update-question-bank/create-update-question-bank.component';
import { ExaminationQuestionBanksComponent } from './exam-layout/operations/examination-question-banks/examination-question-banks.component';
import { EditExaminationQuestionBankComponent } from './exam-layout/operations/edit-examination-question-bank/edit-examination-question-bank.component';
import { GenericConfirmComponent } from './shared-layout/generic-confirm/generic-confirm.component';
import { DownloadTemplatesComponent } from './template/download-templates/download-templates.component';
import { PsychometricReportComponent } from './exam-layout/operations/psychometric-report/psychometric-report.component';
import { QuestionGroupComponent } from './exam-layout/question-group/question-group.component';
import { QuestionsBankGroupComponent } from './questions-bank/questions-bank-group/questions-bank-group.component';
import { InfologComponent } from './shared-layout/infolog/infolog.component';
import { UploadCandidatesComponent } from './candidates-layout/upload-candidates/upload-candidates.component';
import { UsersComponent } from './users-layout/users/users.component';
import { CreateUserComponent } from './users-layout/create-user/create-user.component';
@NgModule({
  declarations: [
    AppComponent, GridComponent, ConfirmComponent,
    CreateExaminationComponent, ExaminationsComponent, ExaminationCandidatesComponent,
    ExaminationPortalApiParametersComponent, ExaminationSubjectsComponent, ExaminationVenuesComponent,
    ExaminationScriptComponent, UploadQuestionsComponent, ExamUrlComponent, ExamCopyComponent,
    PauseUnpauseExamComponent, AutoDpsComponent, TestQuestionsComponent, ExportQuestionsComponent,
    ExamQuestionsComponent, CreateQuestionsComponent, ExamResultComponent, ExamResultCategoryComponent,
    ExaminationscheduleComponent, ExaminationscheduleUnitsConfigComponent, ExpectedScheduleComponent,
    LoginComponent, ResetPasswordComponent, ForgotPasswordComponent, RequestPasswordSuccessComponent, ResetPasswordSuccessComponent,
    SendCandidatesEmailComponent, SendCandidatesSmsComponent, UploadCandidatePassportComponent, TimePeriodsComponent,
    WebtestParametersComponent, CbtPortalParameterComponent, ProctorServerConfigComponent, ProctorsComponent,
    BuyunitsComponent, AddunitsComponent, UnitsPriceConfigComponent, DashboardComponent,
    ExamScriptComponent, ExamFeedbackComponent, QuestionReportComponent, ExamResultCardComponent,
    FileDownloadComponent, ViewCandidateComponent, QuestionBankComponent,
    ExamScheduleQuestionsComponent, ExamScheduleEssayQuestionsComponent, ExamScheduleBackupsComponent,
    ExamScheduleAddedTimeLogComponent, ExamSchedulePausedTimeLogComponent, ExamScheduleFlagsComponent,
    EssayExamLogComponent, ExtraFieldsLabelComponent, ConfirmExamScheduleRestartComponent,
    RecomputeIssueScoreComponent, AddTimeComponent, PauseCandidateExamComponent, ChangeExamStatusComponent,
    ChangeExamScheduleStartDateTimeComponent, ScheduleCandidateComponent, VerifyPaymentComponent, ExamScriptReportComponent,
    ImportScheduleCandidateComponent, TemplateDownloadComponent, ExamCategoryComponent, AddCategoryComponent, CardBoxComponent, ExamPenaltyComponent,
    UserRegistrationComponent,
    SebInstructionUrlComponent,
    GenerateSebConfigComponent,
    ComplaintsComponent,
    ViewComplaintComponent,
    EmailMessagesComponent,
    SmsMessagesComponent, MarkEssayComponent, MarkSaqComponent, ScoreAdjustmentModalComponent, UploadQuestionsImageComponent, UploadMarksheetComponent, AssignExaminersComponent,
    GenerateMarkSheetComponent, ExamScoreByIpComponent, ExamInstructionsComponent, ComplaintCategoryComponent, AddComplaintCategoryComponent, ComplaintCategoryMappingComponent,
    AddComplaintCategoryMappingComponent, QuestionCategoriesComponent, VeiwScheduleComponent, ExamExaminersComponent, AddExaminerComponent, PasswordUpdateComponent,
    UpdateSaqAnswersComponent, ExamSaqAnswersUpdateComponent, FilterParticipantsPipe, ProcteeComponent, ProcteesComponent, SettingsComponent, VideosComponent, ProcteeflagsComponent,
    QuillEditorComponent,
    ExaminationGroupComponent,
    ExaminersMarkingReportComponent, ExaminersReviewReportComponent, ExamMarkingSummaryReportComponent, ImportCandidatesDataComponent,
    CompanySettingsComponent,
    CandidateSebLockoutsComponent,
    ExamScoreByMacComponent,
    DraggableDirective,
    CategorySelectComponent,
    AddScheduleFlagsComponent,
    ViewExamScriptComponent,
    SafeHtmlPipe,
    ExamQuestionAnalysisComponent,
    ExamQuestionAnalysisExcelComponent,
    ImportPasswordsComponent,
    QuestionsBankComponent,
    CreateUpdateQuestionComponent,
    QuestionsComponent,
    CreateUpdateQuestionBankComponent,
    ExaminationQuestionBanksComponent,
    EditExaminationQuestionBankComponent,
    GenericConfirmComponent,
    DownloadTemplatesComponent,
    PsychometricReportComponent,
    QuestionGroupComponent,
    QuestionsBankGroupComponent,
    InfologComponent,
    UploadCandidatesComponent,
    UsersComponent,
    CreateUserComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // SharedModuleModule,
    CustomLayoutModule,
    SharedModule,
    CommonModule,
    VexModule,
    FormsModule,
    MatIconModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          ['link', 'image' /*, 'video'*/],
          ['clean'], // remove formatting button
          ['save'],
        ],
      },
    }),
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    DataTablesModule,
    NgSelectModule,
    NgbModalModule,
    NgbModule,
    ToastrModule.forRoot({
      // optional config
      // timeOut: 5000,
      positionClass: 'toast-bottom-right',
      // positionClass: 'toast-bottom',
      preventDuplicates: true,
      maxOpened: 0, // 0 = unlimited simultaneous toasts
      closeButton: true,
      autoDismiss: false,
    }),
    CountdownModule,
    NgxPaginationModule,
    SelectDropDownModule,
  ],
  providers: [
    httpInterceptorProviders,
    AuthguardService,
    {
      provide: APP_INITIALIZER,
      useFactory: (iconService: IconService) => () => iconService.preloadOperationIcons(),
      deps: [IconService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
